import Vue from "vue";
import cartFilters from "./cart-filters";
import { getCustomCart, removeItem, addToCart, setQuantity, updateCartNote } from "./cart-requests";
import updateCartBadge from "./cart-count";
import { cloneDeep } from "./helpers";

function initCartApp() {
    console.log("Init cart app");
    var el = document.getElementById("cart-app");
    if (!el) return;
    var token = el.getAttribute("data-token");

    var app = new Vue({
        el: el,
        delimiters: ["${", "}"],
        filters: cartFilters,
        data: {
            cart: null,
            cartErrors: null,
            loading: false,
            editNote: false
        },
        mounted: async function() {
            this.loadCart(true);
        },
        computed: {},
        methods: {
            loadCart: async function(showLoader) {
                if (showLoader) this.loading = true;
                let result = await getCustomCart();
                this.cart = result.body.cart;
                updateCartBadge(this.cart);
                if (showLoader) this.loading = false;
            },
            updateQuantity: async function(line, count) {
                line.qty = parseInt(line.qty) + count;

                if (line.qty > 0) {
                    this.cart.itemTotal = null;
                    this.cart.itemSubtotal = null;
                    this.cart = cloneDeep(this.cart);

                    let result = await setQuantity(token, line.id, line.qty);
                    if (result.body.error) {
                        this.cartErrors = result.body.errors;
                    } else {
                        this.cartErrors = null;
                    }

                    this.loadCart(false);
                } else {
                    this.remove(line);
                }
            },
            updateCartNote: async function(note) {
                this.cart.note = note;
                this.editNote = true;
                let result = await updateCartNote(token, note);
                this.editNote = false;

                if (result.body.error) {
                    this.cartErrors = result.body.errors;
                } else {
                    this.cartErrors = null;
                }

                // this.loadCart(false);
            },
            remove: async function(item) {
                var i = this.cart.lineItems.indexOf(item);
                this.cart.lineItems.splice(i, 1);
                this.cart.itemTotal = null;
                this.cart.itemSubtotal = null;
                this.cart = cloneDeep(this.cart);
                let result = await removeItem(token, item.id);

                this.loadCart(false);
            }
        },
        watch: {}
    });
    // window.cart = app;
}

export default function init() {
    initCartApp();
}
